import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { logError } from "@faire/web--source/common/logging";
import { getSettingTwitterEventNameToId } from "../../settings/getSettingTwitterEventNameToId";
export var twitterAdsInterceptor = function(params) {
    if (params.facebookPixelEvent) {
        try {
            emitTwitterPixelEvent(params.facebookPixelEvent, params.pixelCustomDataParams, {
                eventID: params.eventId
            });
        } catch (_) {
        /* ignore */ }
    }
};
export var emitTwitterPixelEvent = function(event, vars, context) {
    var _vars_contents;
    var twq = getGlobalProperty("twq");
    var twitterAdsPixelId = getGlobalProperty("twitterAdsPixelId");
    if (!twq) {
        logError("twq not initialized");
        return;
    } else if (!twitterAdsPixelId) {
        if (getGlobalProperty("envName") === "production") {
            logError("twitterAdsPixelId is not specified");
        }
        return;
    }
    var eventNameToIDMap = getSettingTwitterEventNameToId();
    var eventID = "tw-" + twitterAdsPixelId + "-" + eventNameToIDMap[event]; //tw-oev03-ofgsl
    var contents = vars === null || vars === void 0 ? void 0 : (_vars_contents = vars.contents) === null || _vars_contents === void 0 ? void 0 : _vars_contents.map(function(content) {
        return {
            content_id: content.id,
            content_price: content.item_price,
            num_items: content.quantity
        };
    });
    var data = {
        value: (vars === null || vars === void 0 ? void 0 : vars.cart_value) ? vars.cart_value : vars === null || vars === void 0 ? void 0 : vars.value,
        currency: vars === null || vars === void 0 ? void 0 : vars.currency,
        conversion_id: context.eventID,
        contents: contents
    };
    twq("event", eventID, data);
};
